import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { StorybookModule } from '@storybook/storybook.module';
import { SharedModule } from '../../../sharedModule/shared.module';
import { AllRecipesComponent } from './integration-details/all-recipes/all-recipes.component';
import { DeleteRecipeComponent } from './integration-details/all-recipes/recipe/delete-recipe/delete-recipe.component';
import { RecipeComponent } from './integration-details/all-recipes/recipe/recipe.component';
import { ApiCredentialDialogComponent } from './integration-details/api-credential-dialog/api-credential-dialog.component';
import { OrderProtectionConnectDialogComponent } from './integration-details/order-protection-connect-dialog/order-protection-connect-dialog.component';
import { IntegrationDetailsOverviewComponent } from './integration-details/integration-details-overview/integration-details-overview.component';
import { IntegrationDetailsComponent } from './integration-details/integration-details.component';
import { GorgiasSettingsComponent } from './integration-details/integration-platform-specific-components/gorgias/gorgias-settings.component';
import { OkendoSettingsComponent } from './integration-details/integration-platform-specific-components/okendo/okendo-settings.component';
import { YotpoSettingsComponent } from './integration-details/integration-platform-specific-components/yotpo/yotpo-settings.component';
import { JudgeMeSettingsComponent } from './integration-details/integration-platform-specific-components/judge-me/judge-me-settings.component';
import { BazaarvoiceSettingsComponent } from './integration-details/integration-platform-specific-components/bazaarvoice/bazaarvoice-settings.component';
import { OrderProtectionSettingsComponent } from './integration-details/integration-platform-specific-components/order-protection/order-protection-settings.component';
import { RichpanelSettingsComponent } from './integration-details/integration-platform-specific-components/richpanel/richpanel-settings.component';
import { TripleWhaleSettingsComponent } from './integration-details/integration-platform-specific-components/triple-whale/triple-whale-settings.component';
import { TripleWhaleMetricsComponent } from './integration-details/integration-platform-specific-components/triple-whale/triple-whale-metrics.component';
import { IntegrationPlatformSpecificComponentsComponent } from './integration-details/integration-platform-specific-components/integration-platform-specific-components.component';
import { DropdownVariableComponent } from './integration-details/recipe-editor/dropdown-variable/dropdown-variable.component';
import { RecipeEditorComponent } from './integration-details/recipe-editor/recipe-editor.component';
import { RecipeTemplateComponent } from './integration-details/recipe-templates/recipe-template/recipe-template.component';
import { RecipeTemplatesComponent } from './integration-details/recipe-templates/recipe-templates.component';
import { IntegrationItemComponent } from './integration-item/integration-item.component';
import { IntegrationsComponent } from './integrations.component';
import { SortTemplates, StringDropdownOption, StringDropdownOptions, VariablePlaceholders } from './pipes/pipes';

@NgModule({
  imports: [StorybookModule, ReactiveFormsModule, SharedModule, CommonModule, MatDialogModule],
  declarations: [
    IntegrationsComponent,
    IntegrationItemComponent,
    IntegrationDetailsComponent,
    IntegrationDetailsOverviewComponent,
    ApiCredentialDialogComponent,
    OrderProtectionConnectDialogComponent,
    RecipeComponent,
    DeleteRecipeComponent,
    GorgiasSettingsComponent,
    OkendoSettingsComponent,
    YotpoSettingsComponent,
    JudgeMeSettingsComponent,
    BazaarvoiceSettingsComponent,
    OrderProtectionSettingsComponent,
    RichpanelSettingsComponent,
    TripleWhaleSettingsComponent,
    TripleWhaleMetricsComponent,
    IntegrationPlatformSpecificComponentsComponent,
    AllRecipesComponent,
    RecipeTemplatesComponent,
    RecipeEditorComponent,
    RecipeTemplateComponent,
    SortTemplates,
    DropdownVariableComponent,
    StringDropdownOptions,
    StringDropdownOption,
    VariablePlaceholders,
  ],
})
export class IntegrationsModule {}
